import React, { useState } from "react";
import Select, { components } from "react-select";

const Option = (props) => {
    return (
        <components.Option {...props}>
            <div className="patient-theme-copy-option">
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                    className="patient-theme-copy-option__checkbox"
                />
                <label>{props.label}</label>
            </div>
        </components.Option>
    );
};

const CheckOptionSelections = ({ options, selectedValue, setSelectedValue, Label, isPageLoading }) => {

    const handleChange = (selectedOptions) => {

        // Check if "Select All" was selected
        if (selectedOptions.some((option) => option.value === "select-all")) {
            if (selectedValue.length === options.length) {
                // Deselect all options if all are already selected
                setSelectedValue([]);
            } else {
                // Select all options
                setSelectedValue(options);
            }
        } else {
            // Normal selection handling
            setSelectedValue(selectedOptions);
        }
    };

    // Add "Select All" option to the top of the options list
    const enhancedOptions = [
        { value: "select-all", label: "Select All" },
        ...options,
    ];

    return (
        <div className="mb-3 patient-theme-copy-field" style={{ width: "100%" }}>
            <label className="patient-theme-copy-label">{Label}</label>
            <Select
                value={selectedValue}
                onChange={handleChange}
                options={enhancedOptions}
                isMulti
                isLoading={isPageLoading}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option }}
                className="basic-multi-select ui-react-select"
                classNamePrefix="select"
            />
        </div>
    );
};

export default CheckOptionSelections;
